import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { MoonStarIcon, SparklesIcon, HeartIcon, ListChecksIcon } from 'lucide-react';
import { SectionWrapper } from '../ui/SectionWrapper';
const results = [{
  icon: MoonStarIcon,
  title: 'Noches más tranquilas',
  description: 'Descanso reparador para toda la familia.'
}, {
  icon: SparklesIcon,
  title: 'Mayor confianza del niño',
  description: 'Autoestima reforzada a través de pequeños logros.'
}, {
  icon: HeartIcon,
  title: 'Menos estrés en el hogar',
  description: 'Un ambiente más relajado y positivo.'
}, {
  icon: ListChecksIcon,
  title: 'Sensación de orden y control',
  description: 'Saber qué hacer en cada momento.'
}];
export function ResultsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <SectionWrapper background="light-blue" data-id="element-157">
      <div ref={ref} data-id="element-158">
        <div className="text-center mb-12" data-id="element-159">
          <h2 className="font-serif text-3xl md:text-4xl text-navy mb-4" data-id="element-160">
            Más descanso, más calma, más bienestar familiar
          </h2>
          <p className="text-navy/70 text-lg max-w-2xl mx-auto" data-id="element-161">
            Cuando el proceso se aborda con calma y estructura, los resultados
            llegan de forma natural.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6 mb-12" data-id="element-162">
          {results.map((result, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          delay: 0.1 + index * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm flex items-start gap-4" data-id="element-163">
              <div className="w-12 h-12 rounded-full bg-gold/10 flex items-center justify-center flex-shrink-0" data-id="element-164">
                <result.icon className="w-6 h-6 text-gold" data-id="element-165" />
              </div>
              <div data-id="element-166">
                <h3 className="font-serif text-xl text-navy mb-1" data-id="element-167">
                  {result.title}
                </h3>
                <p className="text-navy/60" data-id="element-168">{result.description}</p>
              </div>
            </motion.div>)}
        </div>

        {/* Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.98
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        delay: 0.5
      }} className="max-w-2xl mx-auto" data-id="element-169">
          <img src="https://cdn.magicpatterns.com/uploads/84D6ommtMxhNQTxGiY3e6q/4._.png" alt="Niño descansando tranquilamente" className="w-full h-auto rounded-2xl shadow-lg" data-id="element-170" />
        </motion.div>
      </div>
    </SectionWrapper>;
}